import "./index.scss";
import React, { CSSProperties, ReactNode } from "react";
import cn from "classnames";

export type HorizontalCarouselProps = {
  children: ReactNode;
  /**
   * If true, reverse the scroll direction from right to left
   * @default false
   */
  reverse?: boolean;
  /**
   * The duration of the scroll animation in seconds
   * @default 15s
   */
  duration?: number;
  /**
   * Used for e2e and unit test
   */
  dataTestId?: string;
};

const HorizontalCarousel = ({
  children,
  reverse = false,
  duration = 15,
  dataTestId,
}: HorizontalCarouselProps) => {
  const scrollingItemsClasses = cn("horizontal-carousel__items", {
    "horizontal-carousel__items--reverse": reverse,
  });
  const durationStyle = { "--duration": `${duration}s` } as CSSProperties;

  // multiply by 3 if less than 6 items, to make smooth the infinite carousel animation
  const multiplier = React.Children.toArray(children).length <= 6 ? 3 : 2;

  return (
    <div data-testid={dataTestId} className="horizontal-carousel">
      {Array.from(Array(multiplier)).map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          style={durationStyle}
          className={scrollingItemsClasses}
          aria-hidden={index > 0}
        >
          {children}
        </div>
      ))}
    </div>
  );
};

export default HorizontalCarousel;
